import { IonCol, IonRow } from "@ionic/react";
import React, { useEffect, useState } from "react";
import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	Line,
	LineChart,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import Spacer from "../../../../components/spacer";
import CustomTooltip from "./components/CustomTooltip";
import {
	prepCCfrequency,
	prepNWduration,
	prepNWfrequency,
	prepSleepOnset,
} from "./utils";

interface props {
	entries: any;
	labels: any;
}

const ChartsSleep: React.FC<props> = ({ entries, labels }) => {
	const [sleepOnset, setSleepOnset] = useState<any>([]);
	const [curtainCalls, setCurtainCalls] = useState<any>([]);
	const [nightWakings, setNightWakings] = useState<any>([]);
	const [nightWakingDuration, setNightWakingDuration] = useState<any>([]);

	useEffect(() => {
		if (entries) {
			prepareGraphData();
		}
	}, [entries]);

	const prepareGraphData = () => {
		//console.log(entries);
		setSleepOnset(prepSleepOnset(entries));
		setCurtainCalls(prepCCfrequency(entries));
		setNightWakings(prepNWfrequency(entries));
		setNightWakingDuration(prepNWduration(entries));
		//prepareIndependenceGraph();
	};

	return (
		<>
			<IonRow>
				<IonCol>
					<Spacer size="30" />
					<div>
						<h2 className="chart-title">Sleep onset latency</h2>
						<ResponsiveContainer
							width="100%"
							height="100%"
							minWidth="300px"
							minHeight="300px"
						>
							<LineChart
								width={600}
								height={600}
								data={sleepOnset}
								margin={{
									top: 5,
									right: 30,
									left: 20,
									bottom: 5,
								}}
							>
								<CartesianGrid strokeDasharray="3 3" />
								<XAxis dataKey="name" />
								<YAxis />
								<Tooltip
									content={
										<CustomTooltip
											active={""}
											payload={""}
											label={""}
											labels={labels}
										/>
									}
								/>
								<Legend
									margin={{
										top: 10,
										right: 30,
										left: 20,
										bottom: 5,
									}}
								/>
								<Line type="monotone" dataKey="latency" stroke="#8884d8" />
							</LineChart>
						</ResponsiveContainer>
					</div>
				</IonCol>
			</IonRow>
			<IonRow>
				<IonCol>
					<Spacer size="30" />
					<div>
						<h2 className="chart-title">Frequency of curtain calls</h2>
						<ResponsiveContainer
							width="100%"
							height="100%"
							minWidth="300px"
							minHeight="300px"
						>
							<LineChart
								width={600}
								height={600}
								data={curtainCalls}
								margin={{
									top: 5,
									right: 30,
									left: 20,
									bottom: 5,
								}}
							>
								<CartesianGrid strokeDasharray="3 3" />
								<XAxis dataKey="name" />
								<YAxis />
								<Tooltip
									content={
										<CustomTooltip
											active={""}
											payload={""}
											label={""}
											labels={labels}
										/>
									}
								/>
								<Legend
									margin={{
										top: 30,
										right: 30,
										left: 20,
										bottom: 5,
									}}
								/>
								<Line type="monotone" dataKey="frequency" stroke="#8884d8" />
							</LineChart>
						</ResponsiveContainer>
					</div>
				</IonCol>
			</IonRow>
			<IonRow>
				<IonCol>
					<Spacer size="30" />
					<div>
						<h2 className="chart-title">Frequency of night wakings</h2>
						<ResponsiveContainer
							width="100%"
							height="100%"
							minWidth="300px"
							minHeight="300px"
						>
							<LineChart
								width={600}
								height={600}
								data={nightWakings}
								margin={{
									top: 5,
									right: 30,
									left: 20,
									bottom: 5,
								}}
							>
								<CartesianGrid strokeDasharray="3 3" />
								<XAxis dataKey="name" />
								<YAxis />
								<Tooltip
									content={
										<CustomTooltip
											active={""}
											payload={""}
											label={""}
											labels={labels}
										/>
									}
								/>
								<Legend
									margin={{
										top: 10,
										right: 30,
										left: 20,
										bottom: 5,
									}}
								/>
								<Line type="monotone" dataKey="frequency" stroke="#8884d8" />
							</LineChart>
						</ResponsiveContainer>
					</div>
				</IonCol>
			</IonRow>
			<IonRow>
				<IonCol>
					<Spacer size="30" />
					<div>
						<h2 className="chart-title">Duration of night wakings</h2>
						<ResponsiveContainer
							width="100%"
							height="100%"
							minWidth="300px"
							minHeight="300px"
						>
							<LineChart
								width={600}
								height={600}
								data={nightWakingDuration}
								margin={{
									top: 5,
									right: 30,
									left: 20,
									bottom: 5,
								}}
							>
								<CartesianGrid strokeDasharray="3 3" />
								<XAxis dataKey="name" />
								<YAxis />
								<Tooltip
									content={
										<CustomTooltip
											active={""}
											payload={""}
											label={""}
											labels={labels}
										/>
									}
								/>
								<Legend
									margin={{
										top: 10,
										right: 30,
										left: 20,
										bottom: 5,
									}}
								/>
								<Line type="monotone" dataKey="duration" stroke="#8884d8" />
							</LineChart>
						</ResponsiveContainer>
					</div>
				</IonCol>
			</IonRow>
		</>
	);
};

export default ChartsSleep;
